import React, { useState } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify';

const PaymentSection = ({ selected_course, setdiscount, price, setPrice, setstep, code, setcode, CheckCode, loading, isFromCourse, selected_instructor, timeSlot, customer_data, sessionsRequired = 1, selected_sessions = [] }) => {

    const isMultiSession = sessionsRequired > 1;

    const [showPromo, setShowPromo] = useState(false);

    return (
        <div className='contact-section pt-0'>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>Review & Pay</h2>
                <p>Double-check your booking details before you pay.</p>
            </div>

            <div className='booking-review-card mt-4'>
                <div className='booking-review-card-top'>
                    <span className='booking-review-card-icon'>
                        <i className='bi bi-car-front-fill'></i>
                    </span>
                    <div>
                        <h3>{selected_course?.title}</h3>
                        <span>{selected_course?.cartype} Transmission</span>
                    </div>
                </div>

                <div className='booking-review-rows'>
                    {
                        isMultiSession ? (
                            <div className='booking-review-row booking-review-row-sessions'>
                                <span><i className='bi bi-calendar2-week-fill me-2'></i>Lesson Dates ({selected_sessions.length})</span>
                                <span className='booking-review-sessions-list'>
                                    {selected_sessions.map((session, index) => (
                                        <span key={`${session.date}-${session.time}`}>
                                            {index + 1}. {moment(session.date).format('ddd, D MMM')} &middot; {session.time}
                                        </span>
                                    ))}
                                </span>
                            </div>
                        ) : (
                            <>
                                <div className='booking-review-row'>
                                    <span><i className='bi bi-calendar2-fill me-2'></i>Date</span>
                                    <span>{timeSlot?.date}</span>
                                </div>
                                <div className='booking-review-row'>
                                    <span><i className='bi bi-clock-fill me-2'></i>Time</span>
                                    <span>{timeSlot?.time || '-'}</span>
                                </div>
                            </>
                        )
                    }
                    <div className='booking-review-row'>
                        <span><i className='bi bi-person-fill me-2'></i>Instructor</span>
                        <span>{selected_instructor?.name || '-'}</span>
                    </div>
                    <div className='booking-review-row'>
                        <span><i className='bi bi-geo-alt-fill me-2'></i>Pickup</span>
                        <span>{customer_data?.address || '-'}</span>
                    </div>
                </div>

                {
                    isMultiSession && selected_sessions.length < sessionsRequired &&
                    <div className='booking-review-remaining-note'>
                        <i className='bi bi-info-circle-fill me-2'></i>
                        You're booking {selected_sessions.length} of {sessionsRequired} lessons now. You can schedule the remaining {sessionsRequired - selected_sessions.length} from your account after checkout.
                    </div>
                }
            </div>

            <div className='mt-4'>
                {
                    !showPromo ? (
                        <button type='button' className='booking-promo-toggle' onClick={() => setShowPromo(true)}>
                            <i className='bi bi-tag-fill me-2'></i>Have a promo code?
                        </button>
                    ) : (
                        <div className="row clearfix">
                            <div className="input-field d-flex gap-3 form-group">
                                <input
                                    type="text"
                                    name="Promo Code"
                                    value={code}
                                    disabled={price < selected_course?.price}
                                    onChange={(e) => setcode(e.target.value)}
                                    placeholder="Promo Code"
                                />
                                <button className="theme-btn-promo text-white ps-3" disabled={price < selected_course?.price} type='button' onClick={CheckCode}>
                                    Apply
                                </button>
                                {
                                    price < selected_course?.price && (
                                        <button className="bg-black text-white" style={{ padding: "10px 15px" }} type='button' onClick={() => {
                                            setdiscount(0)
                                            setPrice(selected_course?.price)
                                            setcode('')
                                            toast.success("Promo Code Removed");
                                        }}>
                                            Clear
                                        </button>
                                    )}
                            </div>
                        </div>
                    )
                }
            </div>

            <div className='booking-pay-box mt-4'>
                <div className='booking-pay-box-total'>
                    <span>Total</span>
                    <span>£{Number(price).toFixed(2)}</span>
                </div>
                <button disabled={loading} className="booking-pay-now-btn" type='submit'>
                    Pay Now &mdash; £{Number(price).toFixed(2)}
                </button>
                <span className='booking-pay-box-secure'><i className='bi bi-lock-fill me-1'></i>Secure encrypted payment</span>
            </div>

            <div className='text-center mt-4'>
                <button className="booking-back-to-edit" type='button' onClick={() => {
                    if (isFromCourse)
                        setstep(1)
                    else
                        setstep(prev => prev - 1);
                }}>
                    <i className='bi bi-arrow-left me-2'></i>Back to Edit
                </button>
            </div>

        </div>
    )
}

export default PaymentSection
